import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { getReactQueryOptions } from '@_/utils-frontend';
import { publicApiQueryClient } from '#src/api.ts';
import { LinkOptionsBuilder } from '#src/lib/LinkOptionsBuilder.ts';
import { BookLessonPage } from '#src/pages/BookLessonPage/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/book_/$lessonId')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const { queryClient } = context;
    const { lessonId } = params;
    await queryClient.ensureQueryData(lessonQueryOptions({ lessonId }));
  }
});

function RouteComponent() {
  const { lessonId } = Route.useParams();
  const intl = useIntl();

  const query = useSuspenseQuery(lessonQueryOptions({ lessonId }));
  const lesson = query.data.data;

  if (!lesson.canBook) {
    return (
      <Navigate
        {...(lesson.venue
          ? LinkOptionsBuilder.venue({ venue: lesson.venue })
          : LinkOptionsBuilder.organization({
              organization: lesson.organization
            }))}
      />
    );
  }

  return (
    <>
      <Head>
        <title>
          {lesson.isPaymentRequired
            ? intl.formatMessage(
                {
                  id: 'head.book-and-pay-lesson-page',
                  defaultMessage: 'Confirm and pay: {courseName}'
                },
                {
                  courseName: lesson.course?.name
                }
              )
            : intl.formatMessage(
                {
                  id: 'head.book-lesson-page',
                  defaultMessage: 'Confirm your booking: {courseName}'
                },
                {
                  courseName: lesson.course?.name
                }
              )}
        </title>
      </Head>
      <BookLessonPage lesson={lesson} />
    </>
  );
}

function lessonQueryOptions({ lessonId }: { lessonId: string }) {
  return getReactQueryOptions(publicApiQueryClient.lessons.get, {
    params: { id: lessonId }
  });
}
